import type {
  ElementState,
  singleElementState,
  PaginationState,
  DataAnalyticsState,
  singleElementModelizationState,
} from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const elementState: ElementState<any> = {
  data: [],
  error: null,
  loading: false,
};
const singleElement: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

const singleElementModelizationSate: singleElementModelizationState<any> = {
  data: [],
  error: null,
  loading: false,
  progress: null,
};
const paginationState: PaginationState = {
  data: [],
  count: 0,
  error: null,
  loading: false,
};
export const dataAnalyticsState: DataAnalyticsState = {
  variables: paginationState,
  modelizations: elementState,
  modelization: singleElementModelizationSate,
  newScenario: singleElement,
  actualDataAnalyticsConfig: singleElement,
  dataAnalyticsConfig: elementState,
};

export const DataAnalyticsModule = {
  namespaced: true,
  state: dataAnalyticsState,
  getters,
  actions,
  mutations,
};
